/**
 * headerStore — contexttitel voor de app-header (Werkbank-shell).
 *
 * Een pagina zet `title`/`subtitle` ("Haarlem" · "3/14", "WI-336207" · "1/61")
 * en ruimt ze bij unmount weer op via useHeader. Leeg = AppLayout valt terug op
 * de vaste paginatitel. Zustand zonder persist: dit is schermstaat.
 */

import { useEffect } from 'react';
import { create } from 'zustand';

interface HeaderState {
  title: string | null;
  subtitle: string | null;
  set: (title: string | null, subtitle?: string | null) => void;
  clear: () => void;
}

export const useHeaderStore = create<HeaderState>((set) => ({
  title: null,
  subtitle: null,
  set: (title, subtitle = null) => set({ title, subtitle }),
  clear: () => set({ title: null, subtitle: null }),
}));

/** Zet de header-context zolang de pagina gemount is. */
export function useHeader(title: string | null | undefined, subtitle?: string | null) {
  const set = useHeaderStore((s) => s.set);
  const clear = useHeaderStore((s) => s.clear);
  useEffect(() => {
    set(title ?? null, subtitle ?? null);
    return () => clear();
  }, [title, subtitle, set, clear]);
}
